import FroalaEditor from 'froala-editor';

const PLUGIN_NAME = 'textmark';

const WJ = '\u2060'; // WORD JOINER - prevents line break

(function (FroalaEditor) {
  // Add an option for your plugin.
  FroalaEditor.DEFAULTS = Object.assign(FroalaEditor.DEFAULTS, {
    customBlockedElements: [],
  });

  // The editor parameter is the current instance.
  FroalaEditor.PLUGINS[PLUGIN_NAME] = function (editor) {
    const isEnabled = true;
    const customBlockedElements = editor.opts.customBlockedElements || [];

    function _init() {
      if (!isEnabled) return;

      editor.events.on('click', (event: MouseEvent) => {
        if (!(editor.doc.getSelection && editor.doc.createRange)) return;
        let element = event.currentTarget as HTMLElement;
        do {
          if (element?.className?.includes('textmarke')) {
            const selection = editor.doc.getSelection();
            const range = editor.doc.createRange();
            range.selectNodeContents(event.currentTarget);
            selection.removeAllRanges();
            selection.addRange(range);
          }
          element = element?.parentNode as HTMLElement;
        } while (element && element.tagName !== 'BODY');
      });

      editor.events.on(
        'keydown',
        (event: KeyboardEvent) => {
          const key = event.key;
          const code = event.key;

          const blockedElements = ['blockinput', ...customBlockedElements];
          const protectedBlock = editor.selection
            .element()
            .closest(blockedElements.map((x) => `.${x}`).join(', '));

          if (!protectedBlock) return true; // Not in protected block

          // Explicitly allow copy shortcut
          if (key === 'c' && (event.ctrlKey || event.metaKey)) {
            return true;
          }

          event.preventDefault();

          // 🔧 Utility: safely move caret *after* a protected block
          const moveCaretAfterProtectedBlock = (block: HTMLElement) => {
            let next = block.nextSibling;
            if (!(next && next.nodeType === 3 && next.nodeValue === WJ)) {
              const zwsp = document.createTextNode(WJ);
              block.parentNode.insertBefore(zwsp, block.nextSibling);
              next = zwsp;
            }

            const range = document.createRange();
            range.setStartAfter(next);
            range.collapse(true);

            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);

            editor.selection.save();
            editor.selection.restore();
          };

          // 🔧 Utility: safely move caret *before* a protected block
          const moveCaretBeforeProtectedBlock = (block: HTMLElement) => {
            let prev = block.previousSibling;
            if (!(prev && prev.nodeType === 3 && prev.nodeValue === WJ)) {
              const zwsp = document.createTextNode(WJ);
              block.parentNode.insertBefore(zwsp, block);
              prev = zwsp;
            }

            const range = document.createRange();
            range.setStartBefore(prev);
            range.collapse(false);

            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);

            editor.selection.save();
            editor.selection.restore();
          };

          // ⬅️ Navigation keys
          if (code === 'ArrowLeft' || code === 'ArrowUp') {
            moveCaretBeforeProtectedBlock(protectedBlock);
            return false;
          }

          if (code === 'ArrowRight' || code === 'ArrowDown') {
            moveCaretAfterProtectedBlock(protectedBlock);
            return false;
          }

          // 🅰️ Typed characters
          if (event.key.length === 1) {
            const range = editor.selection.ranges(0);

            if (
              protectedBlock.textContent.length === range.endOffset &&
              range.endOffset === range.startOffset
            ) {
              moveCaretAfterProtectedBlock(protectedBlock);
            } else {
              moveCaretBeforeProtectedBlock(protectedBlock);
            }

            // Final safety check
            const newRange = editor.selection.ranges(0);
            const currentNode = newRange.startContainer;

            if (
              protectedBlock.contains(currentNode) ||
              protectedBlock === currentNode
            ) {
              const textNode = document.createTextNode(key);
              protectedBlock.parentNode.insertBefore(textNode, protectedBlock);

              const range = document.createRange();
              range.setStartAfter(textNode);
              range.collapse(true);

              const sel = window.getSelection();
              sel.removeAllRanges();
              sel.addRange(range);
            }
          }

          if (event.key === 'Enter') {
            const range = editor.selection.ranges(0);
            if (
              protectedBlock.textContent.length === range.endOffset &&
              range.endOffset === range.startOffset
            ) {
              moveCaretAfterProtectedBlock(protectedBlock);
            } else {
              moveCaretBeforeProtectedBlock(protectedBlock);
            }
            return false;
          }

          // Block other keys like Backspace
          return false;
        },
        true
      );
    }

    return {
      _init,
    };
  };
})(FroalaEditor);
